<script>

export default {
  name: 'TwDomainSelectorModal',
  props: {
    availableDomains: {
      type: Array,
      default: () => [],
    },
    selectedDomains: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toggled: true,
      search: '',
      headers: [
        { text: this.$t('domains.table.shortName'), value: 'shortName' },
        { text: this.$t('domains.table.name'), value: 'name' },
      ],
      pagination: {
        rowsPerPage: 10,
        descending: false,
        sortBy: 'description',
      },
      localAvailableDomains: [],
      localSelectedDomains: [],
    };
  },
  created() {
    this.localAvailableDomains = [...this.availableDomains];
    this.localSelectedDomains = this.selectedDomains;
  },
  methods: {
    add(event) {
      const selected = [...this.localSelectedDomains];
      const available = [...this.localAvailableDomains];
      const index = this.localAvailableDomains.findIndex(domain => domain.id === event.id);
      selected.push(event);
      available.splice(index, 1);
      this.localAvailableDomains = available;
      this.localSelectedDomains = selected;
    },
    update() {
      this.$emit('update', {
        domainIds: this.localSelectedDomains.map(selectedDomain => selectedDomain.id),
      });
    },
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('cancel');
      }
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="800px"
  >
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>edit</v-icon>
        {{ $t('domains.title') }}
      </v-flex>
      <v-divider light/>
      <v-layout row wrap>
        <v-flex v-if="localSelectedDomains.length" sm12 pa-3>
          <v-chip
            v-for="(selectedDomain, index) in localSelectedDomains"
            :key="`selected-domains__${index}`"
            color="teal"
            text-color="white"
          >
            <span>
              <strong>{{ selectedDomain.shortName }}</strong>
            </span>
          </v-chip>
        </v-flex>
        <v-flex
          v-else
          sm12
          pa-3
          text-xs-center
          class="tw-domain-selector__no-content"
        >
          <i>{{ $t('domains.noDomains') }}</i>
        </v-flex>
        <v-flex sm12>
          <v-text-field
            v-model="search"
            class="px-4"
            clearable
            clear-icon="clear"
            append-icon="search"
            :loading="loading"
            :label="$t('inputs.placeholders.search')"
          />
        </v-flex>
        <v-flex sm12>
          <v-data-table
            class="elevation-1"
            item-key="id"
            :headers="headers"
            :items="localAvailableDomains"
            :pagination.sync="pagination"
            :loading="loading"
            :search="search"
            :no-data-text="$t('domains.table.noData')"
          >
            <template v-slot:items="props">
              <tr
                class="tw-domain-selector__table-row"
                @click="add(props.item)"
              >
                <td>{{ props.item.shortName }}</td>
                <td>{{ props.item.name }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn
          color="red darken-1"
          flat
          @click="toggled = false"
        >
          {{ $t('buttons.cancel') }}
        </v-btn>
        <v-btn
          :disabled="selectedDomains === localSelectedDomains || loading"
          :loading="loading"
          color="blue darken-1"
          flat
          @click="update"
        >
          {{ $t('buttons.save') }}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
  @import '../assets/scss/variables.scss';

  .tw-domain-selector__table-row {
    cursor: pointer;
  }

  .tw-domain-selector__no-content {
    color: $brand-grey-light;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/TwDomainSelectorModal.vue